import type { DragEvent } from "react";
import type { ImageRef } from "../../../../hooks/use-imagery";

export const IMAGE_REF_MIME = "application/x-image-ref";

export function setImageDragRef(event: DragEvent, ref: ImageRef): void {
  event.dataTransfer.setData(IMAGE_REF_MIME, JSON.stringify(ref));
  event.dataTransfer.effectAllowed = "move";
}

export function getImageDragRef(event: DragEvent): ImageRef | null {
  const raw = event.dataTransfer.getData(IMAGE_REF_MIME);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ImageRef;
  } catch {
    return null;
  }
}
